export const pushFormStart = (time, processId) => {
  if (window.truenth.utils.hasConsented()) {
    window.dataLayer.push({
      event: 'custom.form.start',
      group: 'men like me',
      label: undefined,
      info: {
        time
      },
      data: undefined,
      processId
    });
  }
};

export const nameMapper = {
  trt: 'treatment',
  sec_trt: 'secondaryTreatment',
  age_band: 'age',
  stage: 'diseasestage',
  ltc_group: 'otherconditions'
};

export const pushRouteChange = (currentRoute, previousRoute) => {
  if (window.truenth.utils.hasConsented()) {
    window.dataLayer.push({
      event: 'custom.route.change',
      route: {
        current: `${window.location.pathname}${nameMapper[currentRoute] || currentRoute}`,
        previous: `${window.location.pathname}${nameMapper[previousRoute] || previousRoute}`,
        title: nameMapper[currentRoute] || currentRoute
      }
    });
  }
};

export const pushFormFieldComplete = (input, currentStep, timeDiff, data, processId) => {
  if (window.truenth.utils.hasConsented()) {
    window.dataLayer.push({
      event: 'custom.form.field.complete',
      group: 'men like me',
      label: input.label,
      step: {
        sequence: currentStep,
        label: nameMapper[input.name]
      },
      info: {
        time: timeDiff
      },
      data,
      processId
    });
  }
};

export const pushFormFieldView = (input, step, name, timeDiff, processId) => {
  if (window.truenth.utils.hasConsented()) {
    window.dataLayer.push({
      event: 'custom.form.step.view',
      group: 'men like me',
      label: input.label,
      step: {
        sequence: step,
        label: nameMapper[name]
      },
      data: undefined,
      info: {
        time: timeDiff
      },
      processId
    });
  }
};

export const pushFormComplete = (timeSince, selectedValues, processId) => {
  if (window.truenth.utils.hasConsented()) {
    window.dataLayer.push({
      event: 'custom.form.complete',
      group: 'men like me',
      label: 'Show Men Like Me',
      info: {
        time: timeSince
      },
      data: selectedValues,
      processId
    });
  }
};
